import { HttpService } from "./https.service";
import { BASE_URL } from "../../config/config";

const http = new HttpService();

export class PixelService {
    static async generatePixel(data: {
        user_id: number;
        account_id: number;
        influencer_id: number;
        brand_id: number;
        website_url?: string;
        platforms?: string[];
    }): Promise<any> {
        try {
            const path = BASE_URL + "/pixel/generate";
            return await http.postRequest(path, data, null);
        } catch (error) {
            throw new Error(`generatePixel: ${error}`);
        }
    }

    static async getPixelStatus(influencer_id: number, account_id: number): Promise<any> {
        try {
            const path = BASE_URL + `/pixel/status/${influencer_id}/${account_id}`;
            return await http.getRequest(path, null);
        } catch (error) {
            throw new Error(`getPixelStatus: ${error}`);
        }
    }

    static async updateStep(data: {
        influencer_id: number;
        account_id: number;
        onboarding_step: number;
    }): Promise<any> {
        try {
            const path = BASE_URL + "/pixel/step";
            return await http.postRequest(path, data, null);
        } catch (error) {
            throw new Error(`updateStep: ${error}`);
        }
    }

    static async activatePixel(data: {
        influencer_id: number;
        account_id: number;
    }): Promise<any> {
        try {
            const path = BASE_URL + "/pixel/activate";
            return await http.postRequest(path, data, null);
        } catch (error) {
            throw new Error(`activatePixel: ${error}`);
        }
    }

    static async updatePlatforms(data: {
        influencer_id: number;
        account_id: number;
        platforms: string[];
    }): Promise<any> {
        try {
            const path = BASE_URL + "/pixel/platforms";
            return await http.postRequest(path, data, null);
        } catch (error) {
            throw new Error(`updatePlatforms: ${error}`);
        }
    }

    static async getPixelAnalytics(params: {
        start_date?: string;
        end_date?: string;
        cctm_id?: string;
    }): Promise<any> {
        try {
            const qs = new URLSearchParams(
                Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== ''))
            ).toString();
            const path = BASE_URL + `/pixel/admin/analytics${qs ? '?' + qs : ''}`;
            return await http.getRequest(path, null);
        } catch (error) {
            throw new Error(`getPixelAnalytics: ${error}`);
        }
    }
}
